import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';
import StripeCheckout from 'react-stripe-checkout';
import {my_PUBLISHABLE_stripekey,application_free, stripeInfo, URL_VERSION} from '../../../server/constants';
import { get,post,patch,postWithHeadersResponse} from "../../../server/actions";
import {_addNotificationError,allowNumericWithdecimal,_addNotification,calculateStripeCharges} from "../../../server/util";
import { isNull } from 'util';

class InstantCheckOut extends Component{
    constructor(props){
        super(props);
        this.state={
            reqObject:{},
        }
    }
    onToken = (token) => {
        const{lunchBal, paymentObj}= this.props;
        let bal=0.00;
        let _formData={};
        if(lunchBal.selected){
            bal=(paymentObj.balAmount>lunchBal.balAvAmount)?(paymentObj.balAmount-lunchBal.balAvAmount):0
            _formData['walletAmt']=lunchBal.amount;
        }else{
            bal=paymentObj.balAmount
        }
        _formData["paymentType"]="Online";
        _formData["parentUserEmails"]=sessionStorage.getItem('loggedInUserInfo');
        _formData["instantPayAmt"]=bal;
        _formData["transactionToken"]=token.id;
        _formData["transactionFees"]=paymentObj.charges;
        _formData["appFeeAmount"]=application_free;
        const me=this;
        me.props.onToken(_formData);
    }
    render(){
        const {paymentObj} =this.props;
        return(<Fragment>
            <div style={{width:'100%'}}>
                <StripeCheckout
                    name= {this.state.reqObject.schoolName==''?'MealManage':this.state.reqObject.schoolName}
                    ComponentClass="div"
                    panelLabel="Proceed To Pay" // prepended to the amount in the bottom pay button
                    token={this.onToken}            
                    stripeKey={my_PUBLISHABLE_stripekey}
                    amount={((paymentObj===undefined?0.00:( parseFloat(paymentObj.balAmount)+calculateStripeCharges(parseFloat(paymentObj.balAmount))))*100)} // cents
                    currency="USD"    
                    image={((this.state.reqObject.logoUrl==null)?'':this.state.reqObject.logoUrl)==''?"https://s3.amazonaws.com/stripe-uploads/acct_1CNm8hFk5swmLb4napplication-logo-logo_mm_1.png":this.state.reqObject.logoUrl} // the pop-in header image (default none)
                    >
                        <button className="btn btn-success btn-sm btn-block" style={{ fontSize: '14px'}}>
                            Pay With Card
                        </button>
                </StripeCheckout>
            </div>
            </Fragment>)
    }
}
export default InstantCheckOut


// WEBPACK FOOTER //
// ./src/components/Parent/OrderMeals/instantCheckOut.jsx